import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import Swal from 'sweetalert2';

interface Auth0User {
	app_metadata?: {
		modules?: string[];
	};
	[key: string]: unknown;
}

const routeToModuleMap: Record<string, string> = {
	'/model2d': '2D Models',
	'/model3d': '3D Models',
	'/badges': 'Badges',
	'/crosssell': 'Cross Sell',
	'/flexgroup': 'Flex Group',
	'/listeritem': 'Lister Items',
	'/offerings': 'Offering',
	'/offeringoption': 'Offering Option',
	'/pdp': 'PDPs',
	'/pricing': 'Pricing',
	'/shipping': 'Shipping',
	'/sticker': 'Stickers',
	'/products-ordered': 'Products Ordered',
	'/appsetting': 'App Setting',
	'/application': 'API permission',
	'/region': 'Regions',
	'/currency': 'Currencies',
	'/country': 'Countries',
	'/hyperlink': 'Hyperlinks',
	'/photoframe': 'Photoframes',
	'/layout': 'Layouts',
	'/themecategory': 'Category',
	'/themes': 'Themes',
	'/template': 'Templates',
	'/pagebg': 'Page Background',
	'/discount-bulk': 'Bulk Discount',
	'/discount': 'Discount',
	'/discount-voucher': 'Discount Voucher',
};

export function getRequiredModule(path: string): string | null {
	for (const [routePrefix, moduleName] of Object.entries(routeToModuleMap)) {
		if (path === routePrefix || path.startsWith(routePrefix + '/')) {
			return moduleName;
		}
	}
	return null;
}

export function createModuleGuard(getUser: () => Auth0User | undefined) {
	return (
		to: RouteLocationNormalized,
		from: RouteLocationNormalized,
		next: NavigationGuardNext,
	) => {
		const requiredModule = getRequiredModule(to.path);

		if (!requiredModule) {
			next();
			return;
		}

		const user = getUser();
		const allowedModules = user?.app_metadata?.modules || [];

		if (allowedModules.length === 0 || allowedModules.includes(requiredModule)) {
			next();
		} else {
			Swal.fire({
				title: 'Access Denied',
				text: `You don't have permission to access the ${requiredModule} module.`,
				icon: 'error',
				confirmButtonColor: '#FF6600',
			});
			if (from.path === '/') {
				next('/dashboard');
			} else {
				next(false);
			}
		}
	};
}
